import React, { useState,useRef, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import { Button, Modal, Card, CardHeader, CardContent, Divider } from "@mui/material";
import Box from '@mui/material/Box';
import Switch from '@common/Switch';
import { useTheme } from '@mui/styles';
import EditIcon from '@mui/icons-material/Edit';
import logo from "@assets/images/logo.png";

const SX = {
	menuItem:(theme)=>({
		color: theme.palette.text.black,
		fontFamily:theme.typography.fontFamily.primary,
		fontSize: 14,
		fontWeight:600,
		lineHeight: '24px'
	}),
	fCenter:{
		display:'flex',
		justifyContent:'center',
		alignItems:'center'
	},
	container:{
		display:'flex',
		justifyContent:'center',
		alignItems:'center',
		flexDirection:'column',
		height:'100vh'
	},
    card:(theme)=> {
        return ({
		//maxWidth: 550,
		textAlign: "center",
		fontFamily:theme.typography.fontFamily.primary,
		"&.mw-600":{
			minWidth:600
		},
		"&.mw-500":{
			minWidth:500
		},
		"&.mw-400":{
			minWidth:400
		},
		"& img":{
			maxHeight:80,
		},
		"& .no-wrap":{
			whiteSpace:'nowrap',
		},
		"& .d-flex":{
			display:'flex',
			
			"&.flex-ac":{
				alignItems:'center'
			},
		},
		"& h2": {
		  padding: 0,
		  color: theme.palette.text.black,
		  fontSize: 24,
		  fontWeight: 600,
		  letterSpacing: 0.32,
		  lineHeight: "32px",
		},
		"& .close":{
			float:'right',
			cursor:'pointer'
		},
		"& p.MuiTypography-root": {
		  paddingTop: '5px',
		  color: theme.palette.text.black,
		  fontFamily:theme.typography.fontFamily.primary,
		  fontSize: 16,
		  fontWeight: 600,
		  letterSpacing: 0.25,
		  lineHeight: "20px",
		  marginBottom:'16px'
		},
        '& .required':{
            color:'red',
            fontSize:24,
            fontWeight:600
        },
		'& .m-8':{
			margin:'8px'
		},
		'& .pb-0':{
			paddingBottom:0
		},
		'& .link':{
			color:'var(--sm_primary)',
			textDecoration:'underline',
			cursor:'pointer'
		},
		'& .note-sugst':{
			'& span':{
				fontWeight:600,
			},
			'& button':{
				margin:'0 4px 4px 0',
				textTransform:'none'
			}
		},
		'& .MuiAutocomplete-root':{
			maxWidth:460
		},
		'& .dropDown':{
			width: 300,
			cursor:"pointer",
			padding: '16px 4px',
			'&.MuiFormControl-fullWidth':{
				width:'100%'
			},
			"& label": {
			  padding:"10px",
			  //background: theme.palette.background.white,
			  color: theme.palette.text.inputLabel,
			  fontSize: "16px",
			  fontWeight: 600,
			  lineHeight: "24px",
			},
			'& .MuiInputBase-root': {
				height:35,
				background: theme.palette.background.white,
			},
			'& .MuiOutlinedInput-input':{ 
				padding: '16px 14px', 
				textAlign:'left',
				color: theme.palette.text.black,
				fontSize: "16px", 
				fontWeight: 600,
				fontFamily:theme.typography.fontFamily.primary,
			},
			'& .MuiInputLabel-outlined.MuiInputLabel-shrink':{ transform: 'translate(18px, -9px) scale(1)', fontSize:"12px", padding:"5px"},
			 '& fieldset':{ 
			  borderColor: theme.palette.border.primary,
			  '& legend': { fontSize: 12 }
			},
			'& .MuiSelect-select:focus':{
				backgroundColor: theme.palette.background.white
			},
			'& svg':{
				color: 'var(--sm_primary)',
				border: '1px solid var(--sm_primary)',
				borderRadius: '4px'
			},
			"&.small":{
				width:140,
				padding:'6px',
				'& .MuiOutlinedInput-input':{ 
					padding: '6px', 
				}
			},
			'&.sm':{
				width:90,
				padding:0,
				'& .MuiInputBase-root': {
					height:27
			   },
			   '& svg':{
				   right:'3px'
			   },
			   '& .MuiOutlinedInput-input':{ 
				 width:70,
				 padding:0,
			   },
			   '& fieldset':{ 
					border:'none'
			   }
			}
		}
	})},
    confirmModal:{
		//display: 'flex',
		//alignItems: 'center',
		//justifyContent: 'center',
		zIndex:1402,
		'& .p-info':{
			padding:'8px',
			backgroundColor:'#f9f9e4',
			fontSize:16,
			fontWeight:600,
			margin:'0 16px 12px',
			'& .info':{
				fontSize:14,
				fontWeight:500,

			}
		}
	},
    modalActions:(theme)=>({
		fontFamily:theme.typography.fontFamily.primary,
		padding: 3,
		borderTop: '1px solid rgb(190 194 205 / .3)',
		marginTop: '18px',
		display: 'flex',
		justifyContent: 'center',
		width:'100%',
		'& button.button':{
			margin:1,
            fontWeight: 600,
			fontSize:16,
            color:theme.palette.text.black,
            border: " 1px solid var(--sm_primary)",
			minWidth:140,
            textTransform:'none',
            '&.primary':{
                backgroundColor:'var(--sm_primary)',
                color:'white'
            },
            '&.Mui-disabled':{
                borderColor: theme.palette.border.primary,
                backgroundColor:'unset',
                color:'rgba(0, 0, 0, 0.26)',
                cursor:'not-allowed'
            }
		}
	})
}
const menuItemSx = {
	fontFamily:'sans-serif',
	fontSize:15,
	'& .menu-item-hover':{
		visibility:'hidden',
		margin:'0 8px',
		padding:0.5,
		border: '2px solid var(--sm_primary)',
		color: '#000',
		backgroundColor:'#fff',
	},
	'&:hover':{
		'& .menu-item-hover':{
			visibility:'visible',
			cursor:'pointer'
		}
	}
}
const ClinicSelector = ({ userClinics,selectedClinicId, onClinicSwitch,getActivePages,savePref,userPreferences }) => {
    useEffect(()=>{
		//console.log('CLINIC_SELECTION init',userPreferences,userClinics.length);
		userPreferences.clinicSelectionPending && userClinics.length > 1 && openModal(null,{clinicSelectionPending:true});
	},[])
	const theme = useTheme();
    const selectedClinic = useRef(null);
    userClinics.length  && !selectedClinic.current && (selectedClinic.current = userClinics.find(c=>c.clinic_id == selectedClinicId))
    const [current, setCurrent] = useState({clinic:null,lp:null,pages:[],savePref:true});
	const [state,setState] = useState({open:false});
    const handleClose = ()=> setState({open:false});
	const onChange = (value,field='clinic')=>{
		const pv = {...current};
		if(field == 'clinic'){
			const pages = value?getActivePages(value.clinic_id):[];
			pv.lp = pages[0]
			pv.pages = pages;
		}
		setCurrent({...pv,[field]:value});
	}
	const handleConfirm = ()=>{
		const clinicId = current.clinic?.clinic_id;
		if(clinicId){
			console.log('handleClinicChange-clinicId',current);
			const changed = selectedClinic.current?.clinic_id!=clinicId
			selectedClinic.current = current.clinic;
			onClinicSwitch({
				clinicId,
				lp:current.lp?.to,
				changed,
				useAttributes:userPreferences.clinicSelectionPending?{userPreferences:{}}:null,
				savePref:current.savePref
			});
			//savePref({lp:current.savePref?current.lp?.to:null})
		}
        handleClose();
    }
    const openModal = (e,stProps)=>{
        e?.preventDefault();
		const pages = getActivePages(selectedClinic.current.clinic_id);
        setCurrent({clinic:selectedClinic.current,lp:pages[0],savePref:true,pages});
        setState({open:true,...stProps});
    }
	const isChanged = ()=>current.lp && current.clinic;//state.clinicSelectionPending || (current.lp && current.clinic && selectedClinic.current.clinic_id!=current.clinic.clinic_id)
    return <>
	{userClinics.length>1 && <Box sx={{fontSize:15,fontWeight:700,color:'#fff',display:'flex',cursor:'pointer',padding:1.5,backgroundColor:'var(--sm_primary)'}} onClick={openModal}>{selectedClinic.current?.display_name} <Box sx={{fontSize:14,fontWeight:500,ml:0.6,color:'#fff',display:'flex',alignItems:'center'}} ><EditIcon sx={{fontSize:16}}/></Box></Box>} 
	<Modal open={state.open} sx={SX.confirmModal}>
        <Card sx={SX.card(theme)} >
			<Box sx={SX.container}>
				<CardHeader title={<>
					    <img src={logo} alt="Niman Healthcare" />
						<h2>You're associated with multiple clinics—please choose one to proceed.</h2>
					</>} />
				<Divider sx={{width:'100%'}}/>
				<CardContent sx={{width:800}}>
					<Box sx={{display:'flex',justifyContent:'space-between'}}>
						<Box sx={{display:'flex',flexDirection:'column',width:'49%',alignItems:'flex-start'}}>
							<Box sx={{fontWeight:700,mb:1}}>Clinic</Box>
							<Autocomplete
								options={userClinics}
								getOptionLabel={option=>option.display_name}
								value={current.clinic}
								renderOption={(props,option,{selected}) => {
									const { key, ...optionProps } = props;
									return <Box key={option?.name || option} {...optionProps} component="li" sx={menuItemSx} title={option.name}>
												
											<Box sx={{width:'100%',display:'flex',alignItems:'center'}}>{option?.display_name}</Box>
											</Box>
											}
								}
								isOptionEqualToValue={(option,v)=>(option.clinic_id) == (v?.clinic_id || v)}
								renderInput={(params) => (
									<TextField
										variant="outlined"
										{...params}
									/>
								)}
								slotProps={{
									popper:{
										sx:{zIndex:1405}
									}
								}}
								onChange={(event, newValue) => onChange(newValue)}
								fullWidth
							/>
						</Box>
						<Box sx={{display:'flex',flexDirection:'column',width:'49%',alignItems:'flex-start'}}>
							<Box sx={{fontWeight:700,mb:1}}>Landing Page</Box>
							<Autocomplete
								options={current.pages}
								getOptionLabel={option=>option.label}
								value={current.lp}
								renderOption={(props,option,{selected}) => {
									const { key, ...optionProps } = props;
									return <Box key={option?.to || option} {...optionProps} component="li" sx={menuItemSx} title={option.label}>
												
											<Box sx={{width:'100%',display:'flex',alignItems:'center'}}>{option?.label}</Box>
											</Box>
											}
								}
								isOptionEqualToValue={(option,v)=>(option.to) == (v?.to || v)}
								renderInput={(params) => (
									<TextField
										variant="outlined"
										{...params}
									/>
								)}
								slotProps={{
									popper:{
										sx:{zIndex:1405}
									}
								}}
								onChange={(event, newValue) => onChange(newValue,'lp')}
								fullWidth
							/>
						</Box>
					</Box>
					<Box className="d-flex">
						<Switch 
							label="Save Preferrence"
							checked={current.savePref}
							onChange={(e)=>onChange(e.target.checked,'savePref')}
						/> 
					</Box>
					
				</CardContent>
				<Box sx={SX.modalActions(theme)}>
					{!state.clinicSelectionPending && <Button className="button secondary" variant="text" color="secondary" onClick={handleClose}>Cancel</Button> }
					<Button className="button primary" color="primary" disabled={!isChanged()} onClick={handleConfirm}>Continue</Button>
				</Box>
			</Box>
        </Card>
    </Modal></>;
};

export default ClinicSelector;
